import { AbstractScatterVisualization } from './../visualization.abstract.scatter.component';
export class FastIcaGraph extends AbstractScatterVisualization {}
